import script from "./PanelDYK.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelDYK.vue?vue&type=script&setup=true&lang=js"

import "./PanelDYK.vue?vue&type=style&index=0&id=41a13fcb&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41a13fcb"]])

export default __exports__